/* 🤖 this file was generated by svg-to-ts */
export const siriusArrowDownLeft: {
  name: 'arrow_down_left';
  data: string;
} = {
  name: 'arrow_down_left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M18.53 6.53a.75.75 0 0 0-1.06-1.06L6.75 16.19V8.25a.75.75 0 0 0-1.5 0V18a.748.748 0 0 0 .75.75h9.75a.75.75 0 0 0 0-1.5H7.81L18.53 6.53Z" fill="currentColor"/></svg>`
};
